import { Component } from '@angular/core';

@Component({
  selector: 'ds-app-dialog',
  templateUrl: './app-dialog.component.html',
  styleUrls: ['./app-dialog.component.scss']
})
export class AppDialogComponent {

}
